import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page59() {
  useEffect(() => {
    document.title = "Маяк — Страница 58"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page57" />
        <ForwardLink href="/page59" />
      </div>

      <p style={{ textAlign: "right" }}>58.</p>
      <p>Пауза.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Что?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Что?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Что?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Что?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        (быстро, по пятам)<br/>
        Что?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        (быстрее)<br/>
        Что?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        (еще быстрее)<br/>
        Что?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        (как можно быстрее)<br/>
        Что?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        (быстрее того)<br/>
        Что?
      </p>
      <p style={{ display: "flex" }}>
        <div>
          <div style={{ textAlign: "center" }}>МОЛОДОЙ</div>
          Что?
        </div>
        <div style={{ marginLeft: "auto" }}>
          <div style={{ textAlign: "center" }}>СТАРИК (ПРОДОЛЖЕНИЕ)</div>
          Что?
        </div>
      </p>
      <p style={{ display: "flex" }}>
        <div>
          <div style={{ textAlign: "center" }}>МОЛОДОЙ</div>
          Что?
        </div>
        <div style={{ marginLeft: "auto" }}>
          <div style={{ textAlign: "center" }}>СТАРИК (ПРОДОЛЖЕНИЕ)</div>
          Что?
        </div>
      </p>
      <p style={{ display: "flex" }}>
        <div>
          <div style={{ textAlign: "center" }}>МОЛОДОЙ</div>
          Что?
        </div>
        <div style={{ marginLeft: "auto" }}>
          <div style={{ textAlign: "center" }}>СТАРИК (ПРОДОЛЖЕНИЕ)</div>
          Что?
        </div>
      </p>
      <p style={{ display: "flex" }}>
        <div>
          <div style={{ textAlign: "center" }}>МОЛОДОЙ</div>
          Что?
        </div>
        <div style={{ marginLeft: "auto" }}>
          <div style={{ textAlign: "center" }}>СТАРИК (ПРОДОЛЖЕНИЕ)</div>
          Что?
        </div>
      </p>
      <p style={{ display: "flex" }}>
        <div>
          <div style={{ textAlign: "center" }}>МОЛОДОЙ</div>
          Что?
        </div>
        <div style={{ marginLeft: "auto" }}>
          <div style={{ textAlign: "center" }}>СТАРИК (ПРОДОЛЖЕНИЕ)</div>
          Что?
        </div>
      </p>
      <p style={{ display: "flex" }}>
        <div>
          <div style={{ textAlign: "center" }}>МОЛОДОЙ</div>
          Что?
        </div>
        <div style={{ marginLeft: "auto" }}>
          <div style={{ textAlign: "center" }}>СТАРИК (ПРОДОЛЖЕНИЕ)</div>
          Что?
        </div>
      </p>
      <p style={{ textAlign: "right" }}>58.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page57" />
        <ForwardLink href="/page59" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710629453/the-lighthouse-script/soks3shqfxwnueuy0lgn.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page59;
